import { ColumnDef, ColumnMeta } from '@tanstack/react-table'

import AllRowsExpanderCell from '../Cell/AllRowsExpanderCell'
import RowExpanderCell from '../Cell/RowExpanderCell'
import { COLUMN_SIZE } from '../constants'

const ID: string = 'expander'

export const RowExpanderColumn = <T,>(
  isPinned: ColumnMeta<T, unknown>['isPinned'] = false,
): ColumnDef<T> => ({
  accessorKey: ID,
  cell: ({ row }) => <RowExpanderCell row={row} />,
  header: ({ table }) => <AllRowsExpanderCell table={table} />,
  id: ID,
  meta: {
    centered: true,
    isPinned,
    nonClickable: true,
  },
  size: COLUMN_SIZE.XS,
})
